import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { Redirect, Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import NumberFormat from "react-number-format";
import "react-datepicker/dist/react-datepicker.css";
import ExportToExcelAllData from "../../Forms/SExport/ExportToExcelAllData";
import moment from "moment";
import { baseurl } from "../../../baseurl.js";
import axios from "axios";
import { checkPermission } from "../../../Helper.js";
export default function ExportData() {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");

  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  var firstDay = new Date(y, m, 1);

  const [startDate, setStartDate] = useState(firstDay);
  const [endDate, setEndDate] = useState(new Date());
  const [expdatas, setExpdatas] = useState({
    dataExport: [],
    invoice: false,
    estimate: false,
    creditNoteSale: false,
    receipt: false,
    purchaseBill: false,
    subsistence: false,
    mileage: false,
    callChildState: false,
    creditNotePurchase: false,
    supplierPayment: false,
    reimburse: false,
  });
  const [dataC, setDataC] = useState({ invoice: [], name: [] });

  const inputEventS = (startDate) => {
    // console.log(startDate);
    setStartDate(startDate);
    expData(dataC.name, startDate, endDate);
  };

  const inputEventE = (endDate) => {
    // console.log(endDate);
    setEndDate(endDate);
    expData(dataC.name, startDate, endDate);
  };

  const handleChangeCheckBoxe = (e) => {
    let arr = dataC.name;

    let index = arr.findIndex((x) => x.id == e.target.id);

    if (index > -1) {
      arr = [...arr.slice(0, index), ...arr.slice(index + 1)];
    } else {
      arr.push({ name: e.target.name, id: e.target.id });
    }

    setDataC({ name: arr });
    expData(arr, startDate, endDate);
  };
  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
    };
    funCall(0);
    // expData();
  }, []);
  const asyncRollCheck = async (value) => {
    let pathname = "/ExportData";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };

  const expData = (arr, startDate, endDate) => {
    console.log("Params        ---", arr);
    console.log("startDate     ---", startDate);
    console.log("endDate       ---", endDate);
    let resExp;
    axios
      .post(
        `${baseurl}/masterData/getAllExportData`,
        {
          startDate,
          endDate,
          dataC: arr,
          companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let resData = res.data.data;

        for (let index = 0; index < resData.length; index++) {
          resExp = resData[index];
          console.log(resExp);
          setExpdatas({
            dataExport: resExp,
            callChildState: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <div className="rowStyling mt-1">
        <div className=" col-md-12 ">
          <strong>
            <h3>Export Your Data</h3>
          </strong>
          <p className="px-3 py-2">
            On this screen, you can select some or all of your data to be
            exported to a CSV file. This file should be automatically downloaded
            by your browser, and will be called Export-Complete.zip
          </p>
        </div>

        <div className="rowStyling">
          <div className="row">
            <div className="col-md-12">
              <Form name="addNewForm">
                <div className="row m-2">
                  <div className="col-md-4">
                    <Label style={{ fontWeight: "bold" }}>
                      From:
                      <h8 style={{ color: "tomato" }}>*</h8>
                    </Label>
                    <br />
                    <div className="d-flex flex-row">
                      <DatePicker
                        id="startDate"
                        wrapperClassName="datePicker"
                        name="startDate"
                        selected={startDate}
                        className="form-control"
                        placeholderText="dd-mm-yyyy"
                        autoComplete="Off"
                        dateFormat="dd-MM-yyyy"
                        onChange={inputEventS}
                      />{" "}
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText className="calended_icon">
                          <i class="fa fa-calendar-plus-o" aria-hidden="true" />
                        </InputGroupText>
                      </InputGroupAddon>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <Label style={{ fontWeight: "bold" }}>
                      To:
                      <h8 style={{ color: "tomato" }}>*</h8>
                    </Label>
                    <br />
                    <div className="d-flex flex-row">
                      <DatePicker
                        wrapperClassName="datePicker"
                        className="form-control"
                        id="endDate"
                        selected={endDate}
                        name="endDate"
                        placeholderText="dd-mm-yyyy"
                        autoComplete="Off"
                        dateFormat="dd-MM-yyyy"
                        required
                        onChange={inputEventE}
                      />
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText className="calended_icon">
                          <i class="fa fa-calendar-plus-o" aria-hidden="true" />
                        </InputGroupText>
                      </InputGroupAddon>
                    </div>
                  </div>
                </div>
                <hr
                  style={{
                    borderTop: "1px solid rgb(221, 221, 221)",
                    width: "96%",
                    position: "relative",
                    // left: "-15px",
                  }}
                />
                <div className="m-4">
                  <div>
                    <h6>what data whould you like to export</h6>
                  </div>
                  <div className="mx-5">
                    <Input
                      type="checkbox"
                      id="1"
                      name="invoice"
                      // checked={expdatas.invoice}
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />
                    <Label>Invoices </Label>
                    <br />
                    <Input
                      type="checkbox"
                      name="estimate"
                      // checked={expdatas.estimate}
                      id="9"
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />{" "}
                    <Label>Estimate</Label>
                    <br />
                    <Input
                      type="checkbox"
                      name="creditNoteSale"
                      checked={expdatas.creditNoteSale}
                      id="2"
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />{" "}
                    <Label>Create Credit Note</Label>
                    <br />
                    <Input
                      type="checkbox"
                      name="receipt"
                      checked={expdatas.receipt}
                      id="10"
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />{" "}
                    <Label>Someone Paid Me</Label>
                    <br />
                    <Input
                      type="checkbox"
                      name="purchaseBill"
                      checked={expdatas.purchaseBill}
                      id="6"
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />{" "}
                    <Label>Purchase Bill </Label>
                    <br />
                    <Input
                      type="checkbox"
                      name="subsistence"
                      checked={expdatas.subsistence}
                      id="5"
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />{" "}
                    <Label>Subsistence</Label>
                    <br />
                    <Input
                      type="checkbox"
                      name="mileage"
                      checked={expdatas.mileage}
                      id="22"
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />{" "}
                    <Label>Milegae</Label>
                    <br />
                    <Input
                      type="checkbox"
                      name="creditNotePurchase"
                      checked={expdatas.creditNotePurchase}
                      id="7"
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />{" "}
                    <Label>Purchase Credit Note</Label>
                    <br />
                    <Input
                      type="checkbox"
                      name="supplierPayment"
                      checked={expdatas.supplierPayment}
                      id="24"
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />
                    <Label>Supplier Payments</Label>
                    <br />
                    <Input
                      type="checkbox"
                      name="reimburse"
                      checked={expdatas.reimburse}
                      id="25"
                      onChange={(e) => handleChangeCheckBoxe(e)}
                      style={{ display: "inline-block" }}
                    />
                    <Label>Employee Payment</Label>
                  </div>
                </div>
                <hr
                  style={{
                    border: "1px solid ",
                    marginBottom: "3vh",
                    marginTop: "3vh",
                    borderColor: "E4E5E6",
                  }}
                />

                {expdatas.callChildState === true ? (
                  <>
                    <ExportToExcelAllData Data={expdatas.dataExport} />
                  </>
                ) : null}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
